const getTextWidth = (text, font = '14px -apple-system') => {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    if (!context) {
        return 100
    }
    context.font = font
    const metrics = context.measureText(text)
    return Math.round(metrics.width + 80)
}

export const isIdColumn = (col: any): boolean => {
    return typeof col === 'string' && /Id$/.test(col);
};

export function formatNumberWithGrouping(n: number): string {
    if (!Number.isFinite(n)) {
        return String(n);
    }
    const negative = n < 0;
    const abs = Math.abs(n);
    const [intPart, fracPart] = abs.toString().split('.');
    const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const result = fracPart ? `${intFormatted}.${fracPart}` : intFormatted;
    return negative ? `-${result}` : result;
}

export const calculateColumnsWidth = (
    columns: any[],
    source: any[],
    maxWidthPerCell: number = 500
) => {
    const formattedSource = source.map(entry => ({ ...entry }));
    const columnsWithWidth = columns.map(column =>
        Object.assign({}, column, {
            width: getTextWidth(column.title)
        })
    );

    formattedSource.forEach((entry) => {
        columnsWithWidth.forEach((column, indexColumn) => {
            const key = column.dataIndex;
            const cellValue = entry[key];

            let cellWidth = getTextWidth(cellValue);

            if (cellWidth < column.width) {
                cellWidth = column.width;
            }
            if (cellWidth > maxWidthPerCell) {
                cellWidth = maxWidthPerCell;
            }

            columnsWithWidth[indexColumn].width = Math.max(
                columnsWithWidth[indexColumn].width,
                cellWidth
            );
        });
    });

    const tableWidth = columnsWithWidth
        .map(column => column.width)
        .reduce((a, b) => a + b, 0);

    return {
        columns: columnsWithWidth,
        source: formattedSource,
        tableWidth
    };
};

export const toNumberIfPossible = (v: any) => {
    if (typeof v === 'number') return v
    if (typeof v !== 'string') return null

    const s = v.trim()
    if (s === '') return null

    const n = Number(s)
    return Number.isFinite(n) ? n : null
}

export const reportPeriodLabels: Record<string, string> = {
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_3_DAYS: 'Last 3 Days',
    LAST_7_DAYS: 'Last 7 Days',
    LAST_30_DAYS: 'Last 30 Days',
    THIS_MONTH: 'This Month',
    LAST_MONTH: 'Last Month',
    ALL_TIME: 'All Time',
    CUSTOM_RANGE: 'Custom Range',
}



// WEBPACK FOOTER //
// ./src/component/app/report/columnsHelper.ts